import React, { useState } from "react";
import "../../../../../App.css";
import { Layout } from "../../layout";
import { Modal, Select, Table, Tabs } from "antd";
import { useFormik } from "formik";
import {
  useCreateSinglePaymentRequest,
  useGetBatchId,
  useGetUserBankDetails,
} from "../hooks/usePayment";
import { ErrorToast } from "../../../../componets/toast";
import { getCurrentDate } from "../../../../services/utilityService";
import { useNavigate } from "react-router-dom";

const initialValues = {
  month: "",
  briefDescription: "",
  detailedDescription: "",
  compareFile: "",
};

const SalaryAll = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [showPayrollTable, setShowPayrollTable] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string>();
  const [totalPayableSum, setTotalPayableSum] = useState<any>(0);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const { data, error, mutate, isLoading } = useCreateSinglePaymentRequest();
  const {
    data: batchId,
    mutate: mutateBatchId,
    isLoading: isLoadingBatchId,
  } = useGetBatchId();

  const {
    data: bankData,
    mutate: mutateBankData,
    isLoading: isLoadingBankData,
  } = useGetUserBankDetails();

  React.useEffect(() => {
    mutateBatchId();
    mutateBankData();
  }, []);

  function submitPayment() {
    setConfirmationModal(false);

    const accountData = accountToMakePaymentFrom.split("-");

    const updatedArray = dataSource.map((obj) => {
      console.log(obj);
      
      const updatedObj = {
        sourceAccount: accountData[0],
        sourceInstitutionCode: accountData[4],
        destinationInstitutionCode: obj.destinationInstitutionCode,
        destinationAccount: obj.accountNumber,
        email: obj.employeeEmail,
        phoneNumber: obj.employeePhone,
        narration: formik.values.briefDescription,
        amount: parseFloat(obj.payableToEmployee.replace(/[^\d.]/g, '')),
        sourceName: accountData[2],
        destinationName: `${obj.firstName} ${obj.surname}`,
        destAccountName:`${obj.firstName} ${obj.surname}`,
        sourceBankAccountCode: accountData[2],
        destinationBankAccountCode: obj.bankCode,
        paymentStatus: "NEW",
        paymentType: {
          code: "salary_payments",
          description: "Salary Payment",
        },
      };
      return updatedObj;
    });

    mutate(
      {
        data: {
          batchId: batchId,
          narration: "tax",
          paymentType: {
            code: "salaryPayment",
            description: "Salary Payment",
          },
         expenseType: "Personnel",

          paymentInstructions: updatedArray,
        },
      },
      {
        onSuccess: (res: any) => {
          setSuccessModal(true);
        },
      }
    );
  }

  let totalAmount = 0;
  const processingFee = 100 * Number(dataSource.length)


  function extractData($event: any) {
    const file = $event.target.files[0];
    setFileName(file.name);
    if (file.type === "text/csv") {
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (event: any) => {
        const csvString = event.target.result;

        let rows = csvString.split("\n");

        rows = rows.filter((line) => line.trim() !== "");

        const headers = rows[0].trim().split(",");
        const data: any[] = [];

        for (let i = 1; i < rows.length; i++) {
          let values = rows[i].trim();
          values = values.split(",");

          const obj = {};
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j].trim()] = values[j].trim();
            if (j === 3) {
              let amount = values[j].replace("₦", "$");
               obj[headers[j].trim()] = Number(amount).toLocaleString("en-NG", {
                style: "currency",
                currency: "NGN",
              });
              amount = Number(amount);
              //console.log("amount: ", totalAmount + amount);
              totalAmount = totalAmount + amount;
              setTotalPayableSum(totalAmount);
            }
          }
          data.push(obj);

          setDataSource(data);

          console.log("dataSource: ", data);
        }
      };
    } else {
      ErrorToast("Invalid File type Select a CSV File");
    }
  }

  const formik = useFormik({
    initialValues,
    // validationSchema: Schema,
    onSubmit: async (values) => {},
  });

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    //console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "Staff ID",
      dataIndex: "staffId",
      key: "staffId",
    },
    {
      title: "Surname",
      dataIndex: "surname",
      key: "surname",
    },
    {
      title: "First name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Payable to employee",
      dataIndex: "payableToEmployee",
      key: "payableToEmployee",
    },
    {
      title: "Employee Bank",
      dataIndex: "employeeBank",
      key: "employeeBank",
    },
    {
      title: "Bank Code",
      dataIndex: "bankCode",
      key: "bankCode",
    },
    {
      title: "Destination Institution Code",
      dataIndex: "destinationInstitutionCode",
      key: "destinationInstitutionCode",
    },
    // {
    //   title: "Branch",
    //   dataIndex: "branch",
    //   key: "branch",
    // },
    {
      title: "Account number",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Employee Email",
      dataIndex: "employeeEmail",
      key: "employeeEmail",
    },
    {
      title: "Employee Phone",
      dataIndex: "employeePhone",
      key: "employeePhone",
    },

  ];
  const [accountToMakePaymentFrom, setAccountToMakePaymentFrom] = useState("");

  const handleSelectAccountChange = (event) => {
    setAccountToMakePaymentFrom(event.target.value);
  };

            const navigate = useNavigate();


    const back = () => {
      navigate("/admin/payment/payroll-payments");
  }

  return (
    <>
      <div className={"salaryAll"}>
        <div className={"salaryAllBreadcrumb"}>
          <div>Payments</div>
          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>
          <div>Salary Payments</div>

          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>

          <div>Salary All</div>
        </div>

        {!showPayrollTable ? (
            <div className={"payrollPaymentForm"}>
              <div>Salary Payment</div>

              <div>Pay month/year</div>

              <div>
                <div>
                  <div className={`mt-1`}>
                    {/*<div className="col-form-label py-0 input-height">*/}
                    {/*    <label className="required fw-bold fs-9">*/}
                    {/*        Select month*/}
                    {/*    </label>*/}
                    {/*</div>*/}

                    <div className={`form-control form-control-solid`}>
                      <select
                          style={{ width: 164 }}
                          className={`no-outline`}
                          placeholder="Select month"
                      >
                        <option value="mon">Select month</option>
                        <option value="jan">January</option>
                        <option value="feb">February</option>
                        <option value="mar">March</option>
                        <option value="apr">April</option>
                        <option value="may">May</option>
                        <option value="jun">June</option>
                        <option value="jul">July</option>
                        <option value="aug">August</option>
                        <option value="sept">September</option>
                        <option value="oct">October</option>
                        <option value="nov">November</option>
                        <option value="dec">December</option>
                      </select>
                    </div>

                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block fs-9 text-danger">
                        {formik.touched.month &&
                            formik.errors.month &&
                            formik.errors.month}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className={`mt-1`}>
                    {/*<div className="col-form-label py-0 input-height">*/}
                    {/*    <label className="required fw-bold fs-9">*/}
                    {/*        Select year*/}
                    {/*    </label>*/}
                    {/*</div>*/}

                    <div className={`form-control form-control-solid`}>
                      <select
                          style={{ width: 164 }}
                          className={`no-outline`}
                          placeholder="Select year"
                      >
                      <option value="0">Select year</option>
                        <option value="1">2024</option>
                        <option value="2">2023</option>
                        <option value="3">2022</option>
                        <option value="4">2021</option>
                        <option value="5">2020</option>
                        <option value="6">2019</option>
                        <option value="7">2018</option>
                        <option value="8">2017</option>
                        <option value="9">2016</option>
                        <option value="10">2015</option>
                        <option value="11">2014</option>
                        <option value="12">2013</option>
                        <option value="13">2012</option>
                      </select>
                    </div>

                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block fs-9 text-danger">
                        {formik.touched.month &&
                            formik.errors.month &&
                            formik.errors.month}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"ppFileUploadDiv"}>
                <div>File</div>

                <label>
                  <div>Browse...</div>
                  <div>{fileName ? fileName : "No file selected"}</div>
                  <input
                      hidden
                      id="input"
                      type="file"
                      accept="text/csv"
                      onChange={extractData}
                  />
                </label>

                <div className={"fileTypeText"}>Accepted file format is .csv</div>
              </div>

              <div className={"ppDescriptions"}>
                <div className={`mt-1`}>
                  <div className="col-lg-7 col-form-label py-0 input-height">
                    <label>Select account to make payment from</label>
                  </div>

                  <div className={`form-control form-control-solid`}>
                    <select
                        className={`no-outline fs-8 text-muted`}
                        placeholder="Select account to make payment from*"
                        onChange={(e: any) => handleSelectAccountChange(e)}
                    >
                      <option value="">
                        Select account to make payment from
                      </option>
                      {bankData?.map((array: any, i: any) => {
                        return (
                            <option
                                value={`${array.accountNumber}-${array.bankName}-${array.institutionCode}`}
                                key={i}
                            >
                              {array?.bankName}- {array?.accountNumber}-₦{array?.balance.toLocaleString()}
                            </option>
                        );
                      })}
                    </select>
                  </div>

                  {/*<div className="fv-plugins-message-container input-height">*/}
                  {/*    <div className="fv-help-block fs-9 text-danger">*/}
                  {/*        {formik.touched.briefDescription &&*/}
                  {/*            formik.errors.briefDescription &&*/}
                  {/*            formik.errors.briefDescription}*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                </div>
              </div>

              <div className={"ppDescriptions"}>
                <div className={`mt-1`}>
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    <label>Brief description</label>
                  </div>

                  <div className={`form-control form-control-solid`}>
                    <input
                        className={`no-outline fs-8 ${
                            formik.values.briefDescription !== ""
                                ? "text-dark"
                                : "text-muted"
                        } `}
                        {...formik.getFieldProps("briefDescription")}
                        placeholder="Type here..."
                    ></input>
                  </div>

                  {/*<div className="fv-plugins-message-container input-height">*/}
                  {/*    <div className="fv-help-block fs-9 text-danger">*/}
                  {/*        {formik.touched.briefDescription &&*/}
                  {/*            formik.errors.briefDescription &&*/}
                  {/*            formik.errors.briefDescription}*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                </div>
              </div>

              <div className={"ppDescriptions"}>
                <div className={`mt-1`}>
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    <label>Detailed description</label>
                  </div>

                  <div className={`form-control form-control-solid`}>
                    <input
                        className={`no-outline fs-8 ${
                            formik.values.detailedDescription !== ""
                                ? "text-dark"
                                : "text-muted"
                        } `}
                        {...formik.getFieldProps("detailedDescription")}
                        placeholder="Type here..."
                    ></input>
                  </div>

                  {/*<div className="fv-plugins-message-container input-height">*/}
                  {/*    <div className="fv-help-block fs-9 text-danger">*/}
                  {/*        {formik.touched.detailedDescription &&*/}
                  {/*            formik.errors.detailedDescription &&*/}
                  {/*            formik.errors.detailedDescription}*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                </div>
              </div>

              <div className={"ppFileUploadDiv"}>
                <div>Documents required for approval (if any)</div>

                <label>
                  <div>Browse...</div>
                  <div>{"No file selected"}</div>
                  <input hidden id="input" type="file" />
                </label>
              </div>

              <div>
                <div className={"soCancelButton"}>
                  <button onClick={back}>Cancel</button>
                </div>

                {formik.isValid && formik.dirty && dataSource.length !== 0 ? (
                    <div className={"soPreviewButton"}>
                      <button onClick={() => setShowPayrollTable(true)}>
                        Preview
                      </button>
                    </div>
                ) : (
                    <div className={"soPreviewButton"}>
                      <button
                          disabled
                          onClick={() => setShowPayrollTable(false)}
                          style={{ background: "#666666" }}
                      >
                        Preview
                      </button>
                    </div>
                )}
              </div>
            </div>

          ) : (
          <div className={"ppBreakdown"}>
            <div className={"ppBreakdownRow1"}>
              <div>Salary Payment breakdown</div>

              <div>
                <div>
                  <div>
                    <div className={"batchNoDate"}>Batch Number:</div>
                    <div className={"batchNoDateValue"}>{batchId}</div>
                    {/*<div className={'batchNoDateValue'}>{formik.values.batchNo}</div>*/}
                  </div>

                  <div>
                    <div className={"batchNoDate"}>Date of Transaction</div>
                    <div className={"batchNoDateValue"}>{getCurrentDate()}</div>
                    {/*<div className={'batchNoDateValue'}>{formik.values.batchDate}</div>*/}
                  </div>
                </div>

                <div>
                  <div className={"gtpAmt"}>
                    ₦{(totalPayableSum + processingFee).toLocaleString()}
                  </div>
                  {/*<div className={'gtpAmt'}>₦15,953,350</div>*/}
                  <div className={"gtp"}>Grand total payable</div>
                </div>
              </div>

              <div>
                <div>
                  <div className={"ppTotalTitle"}>Total Salary Amount</div>
                  <div className={"ppTotalAmt"}>₦{totalPayableSum.toLocaleString()}</div>
                </div>

                <div>
                  <div>
                    <div className={"ppTotalTitle"}>
                      Total Salary Payable Amount
                    </div>
                    <div className={"ppTotalAmt"}>₦{totalPayableSum.toLocaleString()}</div>
                  </div>

                  <div>
                    <div className={"ppTotalTitle"}>Processing Fee</div>
                    <div className={"ppTotalAmt"}>₦{processingFee.toLocaleString()}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className={"ppBreakdownRow2"}>
              <div>
                {/*<div>*/}
                {/*    <button>*/}
                {/*        <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                {/*            <path d="M13.0011 14H16.0011V11H18.0011V14H21.0011V16H18.0011V19H16.0011V16H13.0011V14ZM11.0011 16.88C11.0411 17.18 10.9411 17.5 10.7211 17.71C10.3211 18.1 9.69111 18.1 9.30111 17.71L5.29111 13.7C5.18204 13.5934 5.09911 13.463 5.04881 13.319C4.9985 13.175 4.98217 13.0213 5.00111 12.87V7.75L0.211108 1.62C0.0487161 1.41153 -0.0245586 1.14726 0.00729554 0.88493C0.0391497 0.622602 0.173543 0.383546 0.381108 0.22C0.571108 0.08 0.781108 0 1.00111 0H15.0011C15.2211 0 15.4311 0.08 15.6211 0.22C15.8287 0.383546 15.9631 0.622602 15.9949 0.88493C16.0268 1.14726 15.9535 1.41153 15.7911 1.62L11.0011 7.75V16.88ZM3.04111 2L7.00111 7.07V12.58L9.00111 14.58V7.05L12.9611 2H3.04111Z" fill="#666666"/>*/}
                {/*        </svg>*/}
                {/*        Add Filters*/}
                {/*    </button>*/}
                {/*</div>*/}

                {/*<div>*/}
                {/*    <button>Reset All</button>*/}
                {/*</div>*/}
              </div>

              <div>
                <button onClick={() => setConfirmationModal(true)}>
                  Submit
                </button>
              </div>
            </div>

            <div className={"ppBreakdownRow3"}>
              <Table
                rowSelection={rowSelection}
                dataSource={[...dataSource]}
                columns={columns}
              />
            </div>
          </div>
        )}

        <Modal
          centered
          style={{ width: "500px", maxWidth: "100%" }}
          open={confirmationModal}
          onOk={() => setConfirmationModal(false)}
          onCancel={() => setConfirmationModal(false)}
          footer={null}
        >
          <div className={"rvpConfirmationModal"}>
            <svg
              style={{ justifySelf: "center" }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                fill="#61CD85"
              />
            </svg>

            {/*<div className={'rdFilterModalRow1'}>*/}
            <div className={"rvpConfirmationModalTitle"}>Confirmation</div>
            {/*</div>*/}

            <div style={{ justifySelf: "center" }}>
              Please confirm you want to proceed with this request
            </div>

            <div className={"rvpConfirmationModalActionButton"}>
              <button
                className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1"
                onClick={() => setConfirmationModal(false)}
              >
                <span className="indicator-label fs-base">Cancel</span>
              </button>

              <button
                onClick={() => submitPayment()}
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
              >
                <span className="indicator-label fs-base text-White">
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          centered
          style={{ width: "500px", maxWidth: "100%" }}
          open={successModal}
          // onOk={() => {
          //   setSuccessModal(false);
          // }}
          // onCancel={() => setSuccessModal(false)}
          footer={null}
        >
          <div className={"rvpConfirmationModal"}>
            <svg
              style={{ justifySelf: "center" }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                stroke="#61CD85"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className={"rvpConfirmationModalTitle"}>Successful!</div>

            <div style={{ textAlign: "center" }}>
              Your transaction with Batch Number{" "}
              <span style={{ color: "#6366F1" }}>{batchId}</span> has been sent
              to the reviewer group for action
            </div>

            <div className={"rvpConfirmationModalActionButton"}>
              <button
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                onClick={() => {
                  setSuccessModal(false);
                  setShowPayrollTable(false);
                  setFileName(undefined);
                  setDataSource([]);
                  formik.resetForm();
                  mutateBatchId();
                }}
              >
                <span className="indicator-label fs-base text-White">Ok</span>
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SalaryAll;
